import type { ReactElement } from "react";

import Svg, { Path, Rect } from "react-native-svg";

import { ColorToken, ColorTokenValues } from "@/ui/theme/tokens";

const VideoSVG = ({
  height = 36,
  testID,
  width = 36,
}: { testID?: string } & Partial<SizeDimensions>): ReactElement<
  Partial<SizeDimensions>,
  "svg"
> => (
  <Svg
    fill="none"
    height={height}
    testID={testID}
    viewBox="0 0 36 36"
    width={width}
  >
    <Rect
      fill={ColorTokenValues[ColorToken.NeutralBackgroundPrimary]}
      fillOpacity="0.95"
      height="36"
      rx="18"
      width="36"
      x="0"
      y="0"
    />
    <Path
      d="M14.4062 23.0312L22.8438 17.875L14.4062 12.7188V23.0312Z"
      fill={ColorTokenValues[ColorToken.Primary100]}
    />
  </Svg>
);

export default VideoSVG;
